import React, { Component } from 'react' 
import { NavBar,List,Avatar,JumboTabs,Space,TabBar} from 'antd-mobile'
import head from '../../static/touxiang.png'
import brackground from '../../static/brackground.png'
export default class UserCenter extends Component {
  render() {
    return (
        <div >
            <div style={{backgroundImage:"url("+brackground+")",
                marginTop:'30px',
                marginLeft:'10px',
                marginRight:'10px',
                borderRadius: "20px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                padding: "10px"}}>
                <NavBar backArrow={false}> 个人中心 </NavBar>  
                <div style={{fontSize: 24,marginTop:'30px' }}>
                    <Space block wrap> 
                        <Avatar src={head} style={{ borderRadius:'10px','--size': '48px' }} /> 
                        <div> 186****9237
                        <p style={{fontSize: 15}}>描述信息长一点描述信息长一点描述信点</p>
                        </div>  
                    </Space>

                </div>    
                <div style={{fontSize: 24,marginTop:'30px' }}>
                    <JumboTabs> 
                        <JumboTabs.Tab  title='订单总量' description='1023' key='animals' disabled  />
                        <JumboTabs.Tab  title='总金额' description='￥100000.00' key='animals' disabled  />
                        <JumboTabs.Tab  title='当月订单' description='666' key='animals' disabled  />
                        <JumboTabs.Tab  title='当月金额' description='￥20000.00' key='animals' disabled  />
                    </JumboTabs> 
                </div>
             </div>
             <div style={{ fontSize: 24,marginTop:'30px' }}>
                <List header='订单列表'>
                    <List.Item>1</List.Item>
                    <List.Item>2</List.Item>
                    <List.Item>3</List.Item>
                </List>
             </div>
        </div>
    )
  }
}

 